import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type {
  ManualProvisionRequest,
  RegisterEdgeResponse,
} from '@/api/endpoints/edges'
import { edgesApi } from '@/api/endpoints/edges'
import { ApiError } from '@/api/types'
import { getErrorMessage } from '@/shared/utils/error-codes'

export function useManualProvisionEdge() {
  const qc = useQueryClient()
  return useMutation<RegisterEdgeResponse, Error, ManualProvisionRequest>({
    mutationFn: (req) => edgesApi.manualProvision(req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['edges'] })
    },
    onError: (err) => {
      if (err instanceof ApiError) {
        toast.error(getErrorMessage(err.status, err.code))
      } else {
        toast.error('Failed to provision edge')
      }
    },
  })
}
